import {httpService, HttpWrapperOptions} from '../../httpWrapper';

const saveAs = require('file-saver').saveAs;
const getMimeType = require('simple-mime')('application/octect-stream');

const isBlob = (value: any) => {
  if (typeof Blob === 'undefined') {
    return false;
  }

  return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
};

const toBlob = (data: any, filename: string) => {
  if (!isBlob(data) && !(data instanceof File)) {
    var mime = getMimeType(filename || '');
    data = new Blob([data], {type: mime});
  }

  return data;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const downloadFileToDisk = async (href: string, fileName: string, token?: string): Promise<string> => {
  const options = new HttpWrapperOptions().ResponseType('arraybuffer');
  const res = await httpService.get(href, options);

  const blob = await toBlob(res, fileName);
  saveAs(blob, fileName);
  return fileName;
};
